var normalizeComponent = require("!../vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../vue-loader/lib/selector?type=script&index=0!./Pencil.vue"
import __vue_script__ from "!!babel-loader!../vue-loader/lib/selector?type=script&index=0!./Pencil.vue"
/* template */
import __vue_template__ from "!!../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b4ada0ae\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../vue-loader/lib/selector?type=template&index=0!./Pencil.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-material-design-icons/Pencil.vue
// module id = Da9Z
// module chunks = 0